import React from 'react';
import { Property } from '../../../types';

interface Props {
  formData: Partial<Property>;
  onChange: (field: keyof Property, value: any) => void;
  availableOwners: string[];
}

export const PropertyGeneralFields: React.FC<Props> = ({ formData, onChange, availableOwners }) => {
  return (
    <div className="space-y-4 text-xs">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Código Inmueble *</label>
          <input
            type="text"
            value={formData.codigo || ''}
            onChange={(e) => onChange('codigo', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500 font-mono"
            placeholder="Ej: 183150-12345"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Código BRP / Inmobiliaria</label>
          <input
            type="text"
            value={formData.codigo_brp || (formData as any).codigo_brp_o_inmobiliaria || ''}
            onChange={(e) => {
              onChange('codigo_brp', e.target.value);
              onChange('codigo_brp_o_inmobiliaria' as any, e.target.value);
            }}
            className="w-full p-2 border rounded-lg focus:ring-sky-500 font-mono"
            placeholder="Ej: 987654"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Estado Inmueble</label>
          <select
            value={formData.status || 'Activo'}
            onChange={(e) => onChange('status', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500 bg-white"
          >
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
            <option value="Eliminado">Eliminado</option>
            <option value="Separado">Separado</option>
            <option value="Vendido">Vendido</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Título del Inmueble</label>
          <input
            type="text"
            value={formData.titulo || ''}
            onChange={(e) => onChange('titulo', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Hermoso Apartamento en Chapinero"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Tipo de Inmueble</label>
          <input
            type="text"
            value={formData.tipoinmueble || ''}
            onChange={(e) => onChange('tipoinmueble', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Apartamento, Casa, Oficina, Local"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Ciudad</label>
          <input
            type="text"
            value={formData.ciudad || ''}
            onChange={(e) => onChange('ciudad', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Bogotá"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Localidad / Zona</label>
          <input
            type="text"
            value={formData.localidad || ''}
            onChange={(e) => onChange('localidad', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Usaquén"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Barrio</label>
          <input
            type="text"
            value={formData.neighborhoodName || (formData as any).barrio || ''}
            onChange={(e) => {
              onChange('neighborhoodName', e.target.value);
              onChange('barrio' as any, e.target.value);
            }}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Santa Bárbara"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="sm:col-span-2">
          <label className="font-bold text-gray-700 block mb-1">Dirección</label>
          <input
            type="text"
            value={formData.direccion || ''}
            onChange={(e) => onChange('direccion', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Calle 123 # 45-67"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Inmobiliaria / Owner</label>
          <input
            type="text"
            list="owners-list"
            value={formData.owner || ''}
            onChange={(e) => onChange('owner', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: 183150-BANCO_DAVIVIENDA"
          />
          <datalist id="owners-list">
            {availableOwners.map((o) => (
              <option key={o} value={o} />
            ))}
          </datalist>
        </div>
      </div>
    </div>
  );
};
